import {chempConstants} from "../../constants";

const initialState = {
  sendboxList: {},
  sendboxOrgList: {},
  isLoading: false,
  isFailure: false,
  receiverList: [],
}

export default function sent(state = initialState, action) {
  switch (action.type) {
      /***********
       송신함 검색조건 변경
       ************/
    case chempConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload
      }

      /*********
       송신함 목록 조회
       **********/
    case chempConstants.SENDBOX_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case chempConstants.SENDBOX_SUCCESS:
      return {
        ...state,
        sendboxList: action.response.data?.payload,
      }
    case chempConstants.SENDBOX_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /*********
       송신함 원본 목록 조회
       **********/
    case chempConstants.SENDBOX_ORG_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case chempConstants.SENDBOX_ORG_SUCCESS:
      return {
        ...state,
        sendboxOrgList: action.response.data?.payload,
        isDelete: false,
      }
    case chempConstants.SENDBOX_ORG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /***********
       증명서 송신함 히스토리 관리
       ************/
    case chempConstants.SENDBOX_HISTORY:
      return {
        ...state,
        history: action.payload
      }


    default:
      return state
  }
}
